import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class AdvTippedText extends React.Component {
  render() {
    return (
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip id={`tooltip-bottom`}>{this.props.tip}</Tooltip>}
      >
        {this.props.noLink ? (
          <p>{this.props.text}</p>
        ) : (
          <a
            onClick={
              this.props.link
                ? undefined
                : (e) => {
                    e.preventDefault();
                    if (this.props.onClick) {
                      this.props.onClick();
                    }
                  }
            }
            href={this.props.link || ''}
          >
            {this.props.text}
          </a>
        )}
      </OverlayTrigger>
    );
  }
}
export default AdvTippedText;
